export default __webpack_public_path__ + "static/LaunchWhite-8c013d64ed249d4f2aa5494e247ca0ae.png";